// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bl-N","rightAdornment":"Header_rightAdornment__gL6_-"};